import React from 'react';
import { Hero } from '../components/Hero';
import { Highlights } from '../components/Highlights';
import { WhoWeHelp } from '../components/WhoWeHelp';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { PropertyProfessionals } from '../components/PropertyProfessionals';
import { CtaBand } from '../components/CtaBand';
import { Contact } from '../components/Contact';
export function Home() {
  return <>
      <Hero data-id="element-208" data-mp="24h0qy1bdf38x" />
      <Highlights data-id="element-209" data-mp="24gsajzg1hfsz" />
      <WhoWeHelp data-id="element-210" data-mp="24g8wittifbk8" />
      <Services data-id="element-211" data-mp="24htrgkjqkwim" />
      <WhyChooseUs data-id="element-212" data-mp="24hahbq0bvcf5" />
      <PropertyProfessionals data-id="element-213" data-mp="24iv9xa330lad" />
      <CtaBand data-id="element-214" data-mp="29fvipsrbg256" />
      <Contact data-id="element-215" data-mp="29f2byrscxcn1" />
    </>;
}